module.exports = __webpack_public_path__ + "img/agent_img.ea12f7ea.jpg";